/* @flow */
/* eslint-disable babel/no-invalid-this */
import DeviceCollection from "nexia_mobile/models/device_collection";
import Editable from "nexia_mobile/models/mixins/editable";
import type { GroupFeature } from "./types";

export default function Group(feature: GroupFeature) {
  // mix in the methods from the Editable class's prototype
  _.extend(this, Editable);

  if (this._groupMembers == null) {
    this._groupMembers = new DeviceCollection();
  }

  this._groupMembers.set(feature.members, { parse: true });
  const associateGroupMembers = () => {
    this._groupMembers.each((member) => {
      member.parentGroup = this;
    });
  };
  associateGroupMembers();
  this._groupMembers.on("add remove reset sort sync", associateGroupMembers);

  this.getGroupMembers = () => {
    return this._groupMembers;
  };

  this.isNameEditable = () => false;
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/group.js